import m from "mithril";
import Requester from "../../shared/request";
import Gateway from "../../shared/app_settings";
import Toasts from "../../shared/toasts";
import i18n from "../../shared/i18n/i18n";
import SessionController from "../../shared/session";
import Loading from "../../shared/loading";
import RouterService from "../../shared/services/router.service";
import Contact_Support_team from "../../public/auth/contact_support_team";
import { SUPPORT_LINK } from "../../shared/constants/constants";
import AuthLogo from "../../shared/components/component_logo";

let loading = true;
let casError = null;
let sessionEnv = () => SessionController.session.environment;
let sessionEnvReady = () => SessionController.session && SessionController.session.environment;

function verifyToken(ticket) {
    Requester.post(Gateway.identity + "login/cas?path=account&ticket=" + ticket,
        {
            "ticket": ticket
        },
        {"Content-Type": "application/json"})
        .then(function (result) {
            SessionController.setSession(result);
            localStorage.setItem("sso-logout", result.identity.ssoLogout);
            RouterService.navigateToAccount();
        })
        .catch(function (error) {
            loading = false;
            const errorCode = error.response && error.response.properties && error.response.properties.errorCode;
            const supportedErrorCodes = ["SharedUserMergedToOtherProfile", "SharedUserEmailLinkedToOtherProfile"];
            if (supportedErrorCodes.includes(errorCode)) {
                casError = errorCode;
                m.redraw();
                return;
            }
            Toasts.error(JSON.stringify(error.response));
        });
}


const AccountPage_Login_SSO_CAS = {
    onremove: function () {
        casError = null;
    },
    oninit: function (vnode) {
        if (SessionController.session && SessionController.session.identity) {
            RouterService.navigateToAccount();
            Toasts.add("success", i18n.t("already_logged_in"), "");
        }

        if (m.route.param("ticket")) {
            verifyToken(m.route.param("ticket"));
        } else {
            RouterService.navigateToAccountCasLogin();
            Toasts.add("error", i18n.t("cant_verify"), i18n.t("invalid_service_url"));
        }

    },
    view: function () {
        return [
            m(".splash-container", [
                loading ? m(Loading, {class: "loading-inline"})
                    : [
                        casError ? [
                            m(AuthLogo),
                            sessionEnvReady() && sessionEnv().about ? [
                                m("div.company-tagline", sessionEnv().about),
                            ] : "",
                            m(".mt-2.pt-2.text-center", [
                            m("i.icon-info.text-danger.icon-big", {style: ""}),
                            i18n.tWithNodes(casError, {
                                contact_our_support_team_link: m("a.hyperlink", {target: "_blank", href: SUPPORT_LINK}, i18n.t("contact_our_support_team"))
                            })
                        ])] : [
                            m("h3.mb-2", i18n.t("unable_to_log_in")),
                            m(".mb-1", i18n.t("please_try_again_or_contact_support")),
                            SessionController.session && SessionController.session.environment && !SessionController.session.environment.ssoOnly ? [
                                m(m.route.Link, {href: RouterService.getAccountLoginUrl(), class: "btn-text"}, i18n.t("back_to_log_in"))
                            ] : "",
                        ],
                        casError ? m(Contact_Support_team) : null
                    ]
            ])
        ];
    }
};
export default AccountPage_Login_SSO_CAS;
